var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-button flex items-center py-3 text-white",class:[
    _vm.icon ? 'justify-start' : 'justify-center',
    _vm.secondary ? 'secondary' : '',
    { disabled: !_vm.confirmedStatus } ],style:(_vm.buttonStyle),on:{"click":_vm.handleClick}},[(_vm.$slots.icon)?_c('div',{staticClass:"icon-wrapper ml-5 mr-3 flex justify-center"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }